<template>
  <div class="preview_warp">
    <div class="header_logo">
      <img src="../../../../../assets/image/pre_icon.jpg" alt="" />
    </div>
    <div class="carousel_warp">
      <el-carousel height="375px" :interval="5000" arrow="always">
        <template v-if="value.head_imgs.length">
          <el-carousel-item  v-for="item in value.head_imgs" :key="item">
          <img :src="item" />
        </el-carousel-item>
        </template>
       
        <el-carousel-item height="180px" v-else>
          <div class="demo"></div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="content_warp">
      <div  class="price">
        ¥<span style="margin-left: 6px">{{ value.sale_price?value.sale_price:'0.00' }}</span>
      </div>
      <div class="title">{{ value.title?value.title:'商品标题' }}</div>
    </div>
    <div class="details_warp">
      <div class="details_title">商品详情</div>
      <div class="content">{{ value.desc?value.desc:'详情' }}</div>
      <div class="img_details" v-for="item in value.descimg" :key="item">
        <img :src="item" alt="" />
      </div>
    </div>
    <div class="pay_content">
      <img src="https://img-dbzd.doubaozhidao.com/20230616/1686909742446855.png?x-oss-process=image/quality,q_80/format,jpg"/>
      <!-- <div class="title">—— 购课须知 ——</div>

      <div class="tit_1 brp">购买后如何看课程？</div>
      <div class="tit_2 brp">
        <span class="tit_1">方法一：</span
        >微信发现页点击视频号进入，点击右上角人像，点击订单，找到对应课程订单，点击进入订单详情，点击右下角去上课按钮进入学习。
      </div>

      <div class="tit_2 brp">
        <span class="tit_1">方法二：</span
        >购买成功后将收到短信通知，点击短信内链接直接观看。
      </div>

      <div class="tit_2 brp">
        <span class="tit_1">方法三：</span
        >打开微信APP搜索“豆包知道”小程序或直接长按识别下面小程序二维码进入后，即可在“已购课程”找到你的课程。
      </div>
      <div class="tit_2 brp">
      <el-image class="qrcode" :src="require('../../../../../assets/image/qrcode.jpeg')" :preview-src-list="[require('../../../../../assets/image/qrcode.jpeg')]"  alt=""/>
      </div>
      <div class="tit_1 brp">购买课程能否退款？</div>
      <div class="tit_2 brp">
        由于课程为虚拟商品，购买后无特殊情况不支持退款，请慎重购买。若使用过程中出现任何问题，请联系客服帮您解决～
      </div>
      <div class="tit_1 brp">售后问题如何咨询？</div>
      <div class="tit_2 brp">
        查看视频号主页，私信联系老师，如设计技术问题，可点击课程左下角客服入口反馈给平台
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  }
};
</script>

<style lang="less">
.preview_warp {
  width: 375px;
  height: 750px;
  overflow-y: auto;
  overflow-x: hidden;
  position: absolute;
  top: 150px;
  right: 0;
  z-index: 1;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e6e8f0;
  box-sizing: border-box;
  padding: 0 !important;
  &::-webkit-scrollbar {
    width: 0;
    height: 10px;
  }
  .header_logo {
    width: 100%;
    height: 95px;
    background: #333333;
    img {
      width: 100%;
      height: 95px;
      display: block;
    }
  }
  .carousel_warp {
    width: 100%;
    height: 375px;
    margin-bottom: 10px;
    img {
      display: block;
      height: 375px;
      width: 100%;
    }
    .demo{
      height:375px;
      width: 100%;
      background: rgba(198, 196, 196, 0.5);
    }
  }
  .content_warp {
    width: 100%;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
    .price {
      font-size: 22px;
      font-weight: bold;
      color: red;
      margin-bottom: 10px;
    }
    .title {
      width: 100%;
      display: inline-block;
      font-size: 18px;
      font-weight: 400;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .details_warp {
    width: 100%;
    padding: 10px;
    padding-top: 0;
    box-sizing: border-box;
    .details_title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 10px;
    }
    .content {
      font-size: 14px;
      color: #666;
      line-height: 28px;
      word-break: break-all;
    }
    .img_details {
      width: 100%;
      img {
        display: block;
        width: 100%;
        object-fit: cover;
      }
    }
  }
  .pay_content {
    width: 100%;
    img{
      display: block;
      width: 100%;
      object-fit: cover;
    }
    .title {
      width: 100%;
      font-size: 18px;
      font-weight: bold;
      color: #089dee;
      text-align: center;
      margin-bottom: 10px;
    }
    .tit_2 {
      color: #666;
      font-size: 12px;
      .qrcode{
        display: block;
        width: 80px;
        height: 80px;
      }
    }
    .tit_1 {
      font-size: 14px;
      color: #089dee;
    }
    .brp {
      margin-bottom: 6px;
    }
  }
}

</style>